module.exports = __webpack_public_path__ + "static/assets/35efc91659039e43f27f819a02a62632.png";